import PropTypes from 'prop-types';
import {
  pointsOnOrderDeliveryActivityJsonSchema,
  pointsOnOrderDeliveryActivityUiSchema
} from '@/services/schema/activity';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';

const PointsOnOrderDeliverySetUp = ({formData, handleFormChange}) => {
  return (
    <JsonFormsWrapper
      jsonschema={pointsOnOrderDeliveryActivityJsonSchema}
      uischema={pointsOnOrderDeliveryActivityUiSchema(formData)}
      data={formData}
      onChange={handleFormChange}
    />
  );
};

PointsOnOrderDeliverySetUp.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default PointsOnOrderDeliverySetUp;
